import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { selectPlatformVersion } from '../../../redux/data/selectors';
import {
  supportInfoSelector,
  loggedUserCountrySelector,
} from '../../../redux/context/selectors';

const mapStateToProps = state => ({
  supportInfo: supportInfoSelector(state),
  platformVersion: selectPlatformVersion(state),
  loggedUserCountry: loggedUserCountrySelector(state),
});

export const enhance = compose(
  injectIntl,
  connect(mapStateToProps),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/Support/enhance.js